module.exports = __webpack_public_path__ + "img/painel.3f58eb25.png";